<template>
  <component
    :is="tag"
    v-tippy="{ placement: tooltipPosition, arrow: arrow, theme: theme, allowHTML: true, zIndex: zIndex }"
    :content="label"
  >
    <slot />
  </component>
</template>

<script setup>
// v-tippy documentation: https://vue-tippy.netlify.app/
defineProps({
  tag: {
    type: String,
    default: 'div',
  },
  label: {
    type: String,
    default: null,
  },
  theme: {
    type: String,
    default: 'light',
  },
  tooltipPosition: {
    type: String,
    default: 'right',
  },
  arrow: {
    type: Boolean,
    default: true,
  },
  zIndex: {
    type: Number,
    default: 99999,
  },
})
</script>
<style>
/* logocustom theme */
.tippy-box[data-theme~='logocustom'] {
  padding: 8px 12px;
  font-size: 14px;
  color: white;
  border-radius: 8px;
  background-color: var(--tw-color-gray-800);
  box-shadow:
    0 0 20px 4px rgba(154, 161, 177, 0.15),
    0 4px 80px -8px rgba(36, 40, 47, 0.25),
    0 4px 4px -2px rgba(91, 94, 105, 0.15);
  line-height: 21px;
}

.tippy-box[data-theme~='customdarkwithpadding'] {
  padding: 8px 12px;
  font-size: 14px;
  color: white;
  border-radius: 8px;
  background-color: var(--tw-color-gray-800);
  box-shadow:
    0 0 20px 4px rgba(154, 161, 177, 0.15),
    0 4px 80px -8px rgba(36, 40, 47, 0.25),
    0 4px 4px -2px rgba(91, 94, 105, 0.15);
  line-height: 21px;
}

.tippy-box[data-placement^='top'][data-theme~='customdarkwithpadding'] .tippy-arrow::before {
  border-top-color: var(--tw-color-gray-800);
}

.tippy-box[data-placement^='bottom'][data-theme~='customdarkwithpadding'] .tippy-arrow::before {
  border-bottom-color: var(--tw-color-gray-800);
}

.tippy-box[data-placement^='left'][data-theme~='customdarkwithpadding'] .tippy-arrow::before {
  border-left-color: var(--tw-color-gray-800);
}

.tippy-box[data-placement^='right'][data-theme~='customdarkwithpadding'] .tippy-arrow::before {
  border-right-color: var(--tw-color-gray-800);
}

.tippy-box[data-theme~='smalldark'] {
  padding: 6px 8px;
  font-size: 12px;
  color: white;
  background-color: var(--tw-color-gray-800);
  box-shadow:
    0 0 20px 4px rgba(154, 161, 177, 0.15),
    0 4px 80px -8px rgba(36, 40, 47, 0.25),
    0 4px 4px -2px rgba(91, 94, 105, 0.15);
  line-height: 18px;
}
</style>
